import { faFilter, faFilterCircleXmark } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useContext, useState } from 'react';
import { Button } from 'react-bootstrap';
import PipelineFilterDropdown from './pipeline-filter-dropdown';
import { PipelineNotificationContext } from '@/modules/pipelines/contexts/pipeline-notification-context';

export default function PipelineTableHeader({ eventView }: { eventView?: boolean }) {
  const { filters, setFilters } = useContext(PipelineNotificationContext);
  const [showFilterView, setShowFilterView] = useState<boolean>(false);

  return (
    // watch the top '-1px'
    <thead className="z-1 sticky-top bg-quaternary" style={{ top: '-1px' }}>
      {!eventView && (
        <span>
          <Button
            size="sm"
            variant="link"
            className="bg-transparent text-danger position-absolute"
            style={{ right: '1.75rem' }}
            onClick={() => Object.keys(filters).length > 0 && setFilters({})}
          >
            <FontAwesomeIcon icon={faFilterCircleXmark} />
          </Button>

          <Button
            size="sm"
            variant="link"
            className="bg-transparent text-primary-500 position-absolute"
            style={{ right: '0.25rem' }}
            onClick={() => setShowFilterView(!showFilterView)}
          >
            <FontAwesomeIcon icon={faFilter} style={{ paddingBottom: '0.301em' }} />{' '}
            {/* watch the padding of this one */}
          </Button>
        </span>
      )}

      {showFilterView && (
        <>
          <tr className="bg-quaternary">
            <th colSpan={5} className="border-0 bg-quaternary">
              Filter by
            </th>
          </tr>
          <tr className="bg-body">
            <th colSpan={5} className="border-0">
              <PipelineFilterDropdown />
            </th>
          </tr>
        </>
      )}

      <tr className="bg-quaternary">
        <th className="text-center bg-quaternary">Date</th>
        <th className="text-center bg-quaternary">
          <div className={'mb-1 d-container-none d-container-sm-inline'}>Status</div>
        </th>
        <th className="text-center bg-quaternary">Pipeline</th>
        <th className={'text-center bg-quaternary'}>
          <div className={'mb-1 d-container-none d-container-sm-inline'}>Event</div>
        </th>
        <th className="bg-quaternary"></th>
      </tr>
    </thead>
  );
}
